import React from "react";
import { withRouter } from "../../../../utils/tms-with-router/tms-with-router";
const TmsReportSevaSummaryReport = () => {
  return <div>Summary Report</div>;
};
export default withRouter(TmsReportSevaSummaryReport);
